// Used for fetching translations for labels throughout the app
import $api from '@/services/api';

const eventListeners = [];

export default {
  namespaced: true,
  state: {
    labels: {},
  },
  getters: {
    // Gets a single label
    getLabel: state => key => {
      return state.labels[key] || '';
    },
    // Gets a label and replaces target words with other values
    //   target words and value are supplied via the "replacement" object
    getReplaceLabel: state => (key, replacement) => {
      let label = state.labels[key] || '';
      Object.keys(replacement).forEach(k => {
        label = label.split(k).join(replacement[k]);
      });
      return label;
    },
  },
  mutations: {
    setLabels(state, labels) {
      state.labels = labels;
    },
  },
  actions: {
    // Load the labels.  Default to the English value if no translation provided
    async fetch({ commit, dispatch, rootState }) {
      const labels = await $api.get('/v1/common/labels/dashboard');
      const translated = {};
      labels.forEach(label => {
        translated[label.key] = label.value_local || label.value;
      });
      commit('setLabels', translated);

      eventListeners.forEach(p => {
        p();
      });
      eventListeners.splice(0, eventListeners.length);

      const distributorConfig = { rootState };
      if (distributorConfig && distributorConfig.custom_labels) {
        dispatch('setCustomDistributorLabels', distributorConfig.custom_labels);
      }
    },
    setCustomDistributorLabels({ state, commit }, replacementLabels) {
      if (!replacementLabels) return;
      const { labels } = state;
      Object.keys(labels).forEach(key => {
        const text = labels[key];
        replacementLabels.forEach(r => {
          if (text.includes(r.value)) {
            labels[key] = text.replaceAll(r.value, r.replacementValue);
          }
        });
      });
      commit('setLabels', labels);
    },
    async onLabelsLoaded({ state }) {
      if (Object.keys(state.labels).length === 0) {
        const p = new Promise(resolve => {
          eventListeners.push(resolve);
        });
        return p;
      }
      return Promise.resolve();
    },
  },
};
